import { ProductType } from '@inter-ikea-storageone/range';
import PillTypeFilter from 'filters/TypeFilter/PillTypeFilter';
import { FilterType } from 'rangeConfig/@types';

export const framesTypeFilter = {
  component: PillTypeFilter,
  title: 'storageone.typeFilterLabel',
  id: 'kallax-frame-type',
  type: FilterType.FILTER,
  options: [
    {
      id: 'shelf',
      name: 'storageone.filterOptionShelvingUnits',
      types: [ProductType.KALLAX_FRAME]
    },
    {
      id: 'tv-bench',
      name: 'storageone.filterOptionTvBench',
      types: [ProductType.KALLAX_TV_BENCH]
    },
    {
      id: 'desk',
      name: 'storageone.filterOptionDesks',
      types: [ProductType.KALLAX_DESK]
    }
  ]
};
